module.exports = __webpack_public_path__ + "img/logo4.2e4177e1.png";